<template>
  <div class="glocal-feed-page">
    <mobile-header></mobile-header>
    <the-header whiteColor>
      <template v-slot:right>
        <div data-cy="headerRightNavigation" class="header__right-navigation">
          <navbar-search :engage="false"></navbar-search>
          <!-- <a-tooltip class="link-tooltip">
            <template #title>Glocal AI</template>
            <img
              src="@/assets/icons/glocal-ai-icon-navbar-white.svg"
              alt="icon"
              @click="redirectToGlocalAI()"
              class="glocal-ai-icon"
            />
          </a-tooltip> -->
          <a-tooltip placement="bottom">
            <template #title>
              <h1>Requesting a new source?</h1>
              <p>
                In Glocal you can request more publication sources if you do not
                find them in our research source lists.
              </p>
            </template>
          </a-tooltip>
          <a-button
            class="navigation-btn"
            @click="visibleInviteToGlocalModal()"
          >
            <img
              src="@/assets/icons/forward_to_inbox.svg"
              alt="icon"
              class="contact-icon"
            />
            Connect with Others
          </a-button>
          <a-tooltip class="link-tooltip">
            <template #title>Alerts</template>
            <div @click="showNotifications()" class="notification">
              <img
                src="@/assets/icons/notifications-icon.svg"
                alt="icon"
                class="navigation-icon bell-icon"
              />
              <span
                v-if="isNotifications"
                class="notifications-alert"
              ></span>
            </div>
          </a-tooltip>
          <!-- <a-tooltip class="link-tooltip">
            <template #title>Portfolio</template>
            <img
              src="@/assets/icons/portfolio-white.svg"
              alt="icon"
              @click="openPortfolioDrawer()"
              class="navigation-icon"
            />
          </a-tooltip> -->
          <a-tooltip class="link-tooltip">
            <template #title>Network</template>
            <img
              src="@/assets/icons/diversity-icon.png"
              alt="icon"
              @click="openNetworks()"
              class="navigation-icon"
            />
          </a-tooltip>
          <a-tooltip class="link-tooltip profile-dropdown-tootip">
            <a-dropdown :trigger="['click']" placement="bottomRight">
              <a class="ant-dropdown-link">
                <img
                  :src="displayPicture"
                  alt="user"
                  class="navigation-icon icon-account"
                />
              </a>
              <template #overlay>
                <accounts-dropdown></accounts-dropdown>
              </template>
            </a-dropdown>
          </a-tooltip>
        </div>
      </template>
    </the-header>
    <a-row ref="feed-page" id='glocal-feed-page__body' class="glocal-feed-page__body">
      <a-col
        :xs="24"
        :sm="24"
        :md="9"
        :lg="7"
        :xl="7"
        class="glocal-feed-page__body--mobile-sidebar"
      >
         <button class="glocal-feed-page__body--mobile-sidebar--btn" @click="profileSidebarOpen()">
          <img src="@/assets/icons/menu.svg" alt="Icon" />
         </button>
         <button class="glocal-feed-page__body--mobile-sidebar--btn" @click="FeedRecommendationsSidebarOpen()">
          <img src="@/assets/icons/category.png" alt="Icon" class="recommended-icon" />
         </button>
      </a-col>
      <a-col
        :xs="24"
        :sm="11"
        :md="9"
        :lg="7"
        :xl="7"
        class="glocal-feed-page__body--left-side-bar"
      >
        <GlocalFeedProfileSidebar :skeletonLoader="skeletonLoader"/>
      </a-col>
      <a-col
        :xs="24"
        :sm="24"
        :md="15"
        :lg="10"
        :xl="10"
        class="glocal-feed-page__body--feed"
      >
        <GlocalFeedUpload v-if="isLoggedInUser && !isViewingIndividualFeed"  />
        <a-typography-title  v-else :level="4" :ellipsis="true" :content="'Posts shared by '+userProfile.full_name" />
        <div v-if="skeletonLoader">
          <feed-card-skeleton
            v-for="loader in 5"
            :key="loader"
          ></feed-card-skeleton>
        </div>
        <div v-else-if="!skeletonLoader && feeds.length === 0" class="message">
          <p>No feed found</p>
        </div>
        <div class="feed-tabs" v-else>
          <GlocalFeedCard v-for="feed in posts" :key="feed.id" :feedObject="feed" :activeTab="activeKey.name" @articleOpen="articleOpen"/>
          <div v-if="scrollLoading" class="scroll-loader">
            <the-loader></the-loader>
            <p>Loading...</p>
          </div>
        </div>
      </a-col>
      <a-col
        :xs="24"
        :sm="24"
        :md="6"
        :lg="7"
        :xl="7"
        class="glocal-feed-page__body--right-side-bar"
      >
        <GlocalFeedRecommendationsSidebar />
      </a-col>
    </a-row>
  </div>
  <!-- Sidebar Profile Drawer -->
  <a-drawer
    width="85%"
    title="Profile"
    placement="left"
    :visible="profileSidebarDrawerVisible"
    @close="profileSidebarDrawerClose"
    class="network-feed-mobile-sidebar-drawer"
  >
    <GlocalFeedProfileSidebar :skeletonLoader="skeletonLoader"/>
  </a-drawer>
  <!-- Recommended contributors to your feed Drawer -->
  <a-drawer
    width="85%"
    title="Recommended Contributors"
    placement="left"
    :visible="FeedRecommendationsSidebarVisible"
    @close="FeedRecommendationsSidebarClose"
    class="network-feed-mobile-sidebar-drawer"
  >
    <GlocalFeedRecommendationsSidebar />
  </a-drawer>
  <notification-drawer
    :drawer-visibility="showNotificationDrawer"
    @close-drawer="closeNotificationDrawer()"
    :loading="loader"
  ></notification-drawer>
  <portfolio-drawer
    :drawer-visibility="showPortfolioDrawer"
    @close-drawer="closePortfolioDrawer()"
  >
  </portfolio-drawer>
  <invite-to-glocal
    :visibleModal="inviteToGlocalModal"
    @closeModal="closeInviteToGlocalModal"
  >
  </invite-to-glocal>
  <ViewFeedModal
    :visible="visibleViewFeedModal"
    @closeViewFeedModal="toggleViewFeedModal()"
    :viewFeed="sharedFeed"
    :feedObject="sharedFeed"
  />
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TheHeader from "../components/layout/ProfilePageHeader.vue";
import NotificationDrawer from "../components/PdbComponents/Notifications.vue";
import AccountsDropdown from "../components/BaseComponents/AccountsDropdown.vue";
import NavbarSearch from "../components/BaseComponents/NavbarSearch.vue";
import InviteToGlocal from "../components/BaseComponents/InviteToGlocal.vue";
import PortfolioDrawer from "../components/PdbComponents/PortfolioDrawer.vue";
import MobileHeader from "../components/layout/MobileHeader.vue";
import GlocalFeedProfileSidebar from "../components/GlocalFeedPageComponents/GlocalFeedProfileSidebar.vue";
import GlocalFeedRecommendationsSidebar from "../components/GlocalFeedPageComponents/GlocalFeedRecommendationsSidebar.vue";
import GlocalFeedUpload from "../components/GlocalFeedPageComponents/GlocalFeedUpload.vue";
import GlocalFeedCard from "../components/GlocalFeedPageComponents/GlocalFeedCard.vue";
import FeedCardSkeleton from "../components/GlocalFeedPageComponents/FeedCardSkeleton.vue";
import TheLoader from "../components/BaseComponents/TheLoader.vue";
import { defineAsyncComponent } from 'vue'

export default {
  components: {
    TheHeader,
    NotificationDrawer,
    AccountsDropdown,
    NavbarSearch,
    PortfolioDrawer,
    MobileHeader,
    InviteToGlocal,
    GlocalFeedProfileSidebar,
    GlocalFeedRecommendationsSidebar,
    GlocalFeedUpload,
    GlocalFeedCard,
    FeedCardSkeleton,
    TheLoader,
    ViewFeedModal: defineAsyncComponent(() => import('@/components/GlocalFeedPageComponents/ViewFeedModal.vue')),
  },
  data() {
    return {
      inviteToGlocalModal: false,
      loader: true,
      showNotificationDrawer: false,
      showPortfolioDrawer: false,
      showTopicDiscussionDrawer: false,
      skeletonLoader: false,
      scrollLoading: false,
      hasMorePages: false,
      profileSidebarDrawerVisible: false,
      FeedRecommendationsSidebarVisible: false,
      visibleViewFeedModal: false,
      sharedFeed: {}, // type will always be object,
      isViewingIndividualFeed: false
    };
  },
  computed: {
    ...mapGetters({ 
      feeds: "feed/feeds",
      feedScrollHeight:'feed/feedScrollHeight',
      feedPageLimit: 'feed/feedPageLimit',
      hasMoreFeedPages:'feed/hasMoreFeedPages',
      authUserInformation: 'profile/userInformation',
      isLoggedInUser:'profile/isLoggedinUser',
      sharedPostId: 'feed/sharedPostId',
      postActivities: 'feed/postActivities',
      activityPage: 'feed/activityPage',
      commentPage: 'feed/commentPage',
      hasMoreActivityPages: 'feed/hasMoreActivityPages',
      hasMoreCommentPages: 'feed/hasMoreCommentPages',
      activeKey: 'feed/activeKey',
      commentActivities: 'feed/commentActivities'
    }),
    userProfile() {
      return this.$store.getters['profile/selectedUser']
    },
    authUserProfile(){
      return this.$store.getters["profile/userInformation"];
    },
    userId() {
      return this.$store.getters["profile/currentLoginUser"];
    },
    isUserRequest() {
      return this.$store.getters["profile/getUserRequestCount"];
    },
    isNotifications() {
      return this.$store.getters["notification/newNotificationCount"];
    },
    displayPicture() {
      return Object.keys(this.authUserProfile).includes("profile")
        ? this.authUserProfile.profile.profile_picture
        : "";
    },
    
    posts(){
      if (this.activeKey.name === 'feed'){
        return this.feeds
      }else if (this.activeKey.name === 'myactivity'){
        return this.postActivities
      }else if (this.activeKey.name === 'comments'){
        return this.commentActivities.map(post=>{
          const postCommentsLength = post.comments.reduce((accumulator, currentValue)=>{
            return accumulator+1+currentValue.child.length
          },0) 
          const numberOfParentComments = post.comments.reduce((accumulator)=>{
            return accumulator+1
          },0) 
          return {
            ...post,
            loadMoreComments: false,
            commentsLength: postCommentsLength,
            numberOfParentComments
          }
        
        })
      }
      else{
        return []
      }
    }
  },
  watch:{
    '$route.query.id':{
      async handler(val){
        //resetting page for activity and feed
        this.updateFeedPageSize(1);
        this.setHasMoreFeedPage('remaining')

        this.resetActivityOrCommentPageCounter({type:'myactivity'})
        this.resetActivityOrCommentPageCounter({type:'comment'})
        // this.updateActivityPageLimit('remaining')
        this.updateActivityOrCommentPageLimit({type:'myactivity', limit:'remaining'})
        this.updateActivityOrCommentPageLimit({type:'comment', limit:'remaining'})
        this.setActiveKey({'name':'feed', key:0})

        if (val){
          this.isViewingIndividualFeed = true 
          await this.$store.dispatch("profile/fetchUserProfile", {username:this.$route.query?.id});
      }else{
        await this.$store.dispatch('profile/getUserInformation')
        this.isViewingIndividualFeed = false
      }
      await this.fetchAllData()
      // val ?  this.isViewingIndividualFeed = true :  this.isViewingIndividualFeed = false
      },immediate:true
    },
    visibleViewFeedModal: {
      handler(isVisible){
        if (!isVisible){
          this.setSharedPostId(null)
        }
      }
    },
    sharedPostId:{
      handler(id){
          if (id){
            (async ()=>{
              const post = await this.fetchIndividualPost(id)
              if(post){
                this.sharedFeed = post
                this.toggleViewFeedModal()
              }
            })()
          }
      }, immediate: true
    },
    activityPage:{
      handler(newPage, prevPage){
        if (!prevPage || prevPage < newPage ){
        (async()=>{
          await this.fetchActivity({type:'post'})
          this.scrollLoading = false
        })()
      }else{
        this.scrollLoading = false
      }
        
      }
    },
    commentPage:{
      handler(newPage, prevPage){
        if (!prevPage || prevPage < newPage ){
        (async()=>{
          await this.fetchActivity({type:'comment'})
          this.scrollLoading = false
        })()
      }else{
        this.scrollLoading = false
      }
        
      }
    },
    feedPageLimit:{
      handler(newPage, prevPage){
        if (!prevPage || prevPage < newPage ){
        (async()=>{
          await this.fetchFeedList();
          this.scrollLoading = false
        })()
      }else{
        this.scrollLoading = false
      }
      }
    },
    activeKey:{
      handler(activeKey){
        (async()=>{
          this.skeletonLoader = true
          if (activeKey.name === 'feed' && !this.$route.query?.id){
            this.updateFeedPageSize(1);
            this.setHasMoreFeedPage('remaining')
            await this.fetchFeedList();
          }else if (activeKey.name === 'myactivity'){
            this.resetActivityOrCommentPageCounter({type:'myactivity'})
            this.updateActivityOrCommentPageLimit({type:'myactivity', limit:'remaining'})
            await this.fetchActivity({type:'post'})
          }else if (activeKey.name === 'comments'){
            this.resetActivityOrCommentPageCounter({type:'comment'})
            this.updateActivityOrCommentPageLimit({type:'comment', limit:'remaining'})
            await this.fetchActivity({type:'comment'})
          }
          this.skeletonLoader = false
        })();
        
      }, immediate:true
    }

  },
  created(){
    this.$route.query?.id ?  this.isViewingIndividualFeed = true :  this.isViewingIndividualFeed = false
  },
  async mounted(){
    if (this.feedScrollHeight){
      document.getElementById('glocal-feed-page__body').scrollTo({
        top: this.feedScrollHeight,
        behavior: 'smooth'
      });
      this.setScrollHeight(null)
    }

    // Detect when scrolled to bottom.
    const glocalFeedPage = document.querySelector('#glocal-feed-page__body');

    glocalFeedPage.addEventListener('scroll', async () => {
      const scrollPosition = glocalFeedPage.scrollTop + glocalFeedPage.clientHeight;
      const documentHeight = glocalFeedPage.scrollHeight;

      if (scrollPosition >= documentHeight - 100 && !this.scrollLoading) {
        try {
          if (this.hasMoreActivityPages && this.activeKey.name === 'myactivity'){
            this.scrollLoading = true;
            this.incOrDecActivityOrCommentPageCounter({type:this.activeKey.name})
          }else if (this.hasMoreFeedPages && this.activeKey.name === 'feed'){
              this.scrollLoading = true;
              this.updateFeedPageSize();
          }else if (this.hasMoreCommentPages && this.activeKey.name === 'comments'){
              this.scrollLoading = true;
              this.incOrDecActivityOrCommentPageCounter({type:'comment'})
          }
          // Update feed size and fetch more content      
          
        } catch (err) {
          if (err.response && err.response.status === 404) {
            console.error("Error fetching feed:", err);
          } else {
            console.error("Unexpected error:", err);
          }
          this.scrollLoading = false;
        }
      }
    });

    // await this.fetchActivity({type:'post'})

  },
  methods: {
    ...mapActions({
      fetchFeedList: "feed/fetchFeedList",
      setScrollHeight: 'feed/setScrollHeight',
      incrementFeedPageSize: 'feed/incrementFeedPageSize',
      updateFeedPageSize:'feed/updateFeedPageSize',
      setActiveTabKey: 'profile/setActiveTabKey',
      setSelectedUser: 'profile/setSelectedUser',
      toggleLoadingFollowedOrgsState: 'feed/toggleLoadingFollowedOrgsState',
      toggleLoadingFollowersState: 'feed/toggleLoadingFollowersState',
      fetchActivity: 'feed/fetchActivity',
      toggleActivityLoader: 'feed/toggleActivityLoader',
      setSharedPostId: 'feed/setSharedPostId',
      fetchIndividualPost: 'feed/fetchIndividualPost',
      resetActivityOrCommentPageCounter: 'feed/resetActivityOrCommentPageCounter',
      incOrDecActivityOrCommentPageCounter: 'feed/incOrDecActivityOrCommentPageCounter',
      updateActivityOrCommentPageLimit: 'feed/updateActivityOrCommentPageLimit',
      setHasMoreFeedPage: 'feed/setHasMoreFeedPage',
      setActiveKey: 'feed/setActiveKey'
    }),
    visibleInviteToGlocalModal() {
      this.inviteToGlocalModal = true
    },
    closeInviteToGlocalModal() {
      this.inviteToGlocalModal = false
    },
    showNotifications() {
      this.getFeatures();
      this.showNotificationDrawer = true;
    },
    closeNotificationDrawer() {
      this.showNotificationDrawer = false;
    },
    closeTopicDiscussionDrawer() {
      this.showTopicDiscussionDrawer = false;
    },
    async getFeatures() {
      try {
        const response = await this.$store.dispatch(
          "article/getGlocalFeatures"
        );
        if (response.status === 200) {
          this.loader = false;
        }
      } catch (err) {
        console.log(err);
      }
    },
    redirectToGlocalAI() {
      this.$router.push("/glocal-AI");
    },
    openPortfolioDrawer() {
      this.showPortfolioDrawer = true;
    },
    closePortfolioDrawer() {
      this.showPortfolioDrawer = false;
    },
    openNetworks(){
      this.setActiveTabKey('network')
      this.setSelectedUser({...this.authUserInformation.profile, id:this.authUserInformation.id})
      this.$router.push({
        path: `/user/${this.authUserInformation?.profile?.username}/`,
      });
      this.getUserInformation()
    },
    async getUserInformation() {
      try {
        await this.$store.dispatch("profile/fetchUserProfile");
        await this.$store.dispatch("profile/loadExperiences");
        await this.$store.dispatch("profile/getAddedLanguages");
        await this.$store.dispatch("profile/fetchPhotoResume");
        
      } catch (err) {
        console.log(err);
      }
    },
    articleOpen(e){
      const divElements =  document.getElementById('glocal-feed-page__body');
      this.setScrollHeight(divElements.scrollTop)
    },
    profileSidebarOpen() {
      this.profileSidebarDrawerVisible = true;
    },
    profileSidebarDrawerClose() {
      this.profileSidebarDrawerVisible = false;
    },
    FeedRecommendationsSidebarOpen() {
      this.FeedRecommendationsSidebarVisible = true;
    },
    FeedRecommendationsSidebarClose() {
      this.FeedRecommendationsSidebarVisible = false;
    },
    async getFollowes(relation='contributors') {
      try {
        await this.$store.dispatch("feed/fetchContributorsAndOrganizations", {relation, user_id:this.authUserInformation?.id});
      } catch (error) {
        console.log(error);
      }finally {
        this.toggleLoadingFollowersState(false)
      }
    },
    async getFollowedOrgs(relation='contributors') {
      try {
        await this.$store.dispatch("feed/fetchContributorsAndOrganizations", {relation, account_type:'organization', user_id:this.authUserInformation?.id});
      } catch (error) {
        console.log(error);
      } finally{
        this.toggleLoadingFollowedOrgsState(false)
      }
    },
    async fetchAllData(){
      this.skeletonLoader = true;
      this.toggleActivityLoader()
      this.toggleLoadingFollowersState(true)
      this.toggleLoadingFollowedOrgsState(true)
      this.getFollowes();
      this.getFollowes('not_contributors');
      this.getFollowedOrgs();
      this.getFollowedOrgs('not_contributors');
      this.fetchActivity({type:'post'})
      await this.fetchFeedList();
      this.toggleActivityLoader()
      this.skeletonLoader = false;
    },
    toggleViewFeedModal(){
      this.visibleViewFeedModal = !this.visibleViewFeedModal
    }

  },
};
</script>

<style lang="scss">
.glocal-feed-page {
  height: 100vh;
  overflow: hidden;
  background-color: #f7f7f7;
  .profile-page-header-container {
    display: block;
    @include respond(phone-x-small) {
      display: none;
    }
    .header {
      background-color: black !important;

      &__right-navigation {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        z-index: 2;
        width: 100%;
        .navigation-icon {
          color: $color-white;
          margin-left: 3.2rem;
          width: 2.4rem;
          cursor: pointer;
          font-size: 3rem;
          @include respond(phone-large) {
            margin-left: 2rem;
          }
        }
        // .glocal-ai-icon {
        //   width: 4rem;
        //   margin-right: auto;
        //   margin-left: 0.8rem;
        //   cursor: pointer;
        // }
        .notification {
          position: relative;
          margin-left: 3rem;
          width: 1.9rem;
          @include respond(phone-large) {
            margin-left: 2rem;
          }
          .bell-icon {
            width: 1.9rem;
            margin-left: 0;
          }
          .notifications-alert {
            position: absolute;
            content: "";
            width: 0.8rem;
            height: 0.8rem;
            background-color: red;
            border-radius: 100%;
            top: 0.2rem;
            right: 0.2rem;
          }
        }
        .icon-account {
          color: $color-black !important;
          border-radius: 100%;
          border: 0.2rem solid $color-black;
          object-fit: cover;
          font-size: 3rem;
          width: 5.2rem;
          height: 5.2rem;
          background-color: #ebebeb;
        }
        .navigation-btn {
          color: $color-white;
          font-family: $font-primary-medium;
          font-size: 1.6rem;
          background-color: $color-primary;
          padding: 0 2rem;
          height: 3.8rem;
          margin-left: 2rem;
          line-height: normal;
          border: none;
          outline: none;
          text-align: center;
          @include respond(laptop-small) {
            display: none;
          }

          span {
            line-height: 1.8rem;
          }
          .plus-icon {
            width: 1.4rem;
            height: auto;
            margin-right: 1.4rem;
            margin-bottom: 0.35rem;
          }
          .contact-icon {
            width: 2rem;
            height: auto;
            margin-right: 0.9rem;
          }
        }
        .search-filter {
          display: block;
          &__header {
            .btn {
              display: none;
            }
          }
          @include respond(phone-x-small) {
            display: none;
          }
        }
        .profile-dropdown-tootip {
          img {
            margin-left: 0 !important;
          }
        }
      }
    }
  }
  .mobile-navbar-new {
    display: none;
    @include respond(phone-x-small) {
      display: block;
    }
  }
  &__body {
    margin-top: 8rem;
    height: calc(100vh - 8rem);
    padding: 2.3rem 2rem;
    @include respond(tab-land) {
      padding: 2.3rem 1rem;
    }
    @include respond(phone-x-small) {
      padding: 2.3rem 1.5rem;
      margin-top: 11rem;
      max-height: calc(100vh - 11rem);
      height: auto;
    }
    overflow-y: auto;
    &--left-side-bar,
    &--feed,
    &--right-side-bar {
      position: relative;
      padding: 0 2rem;
      @include respond(tab-land) {
        padding: 0 1rem;
      }
    }
    &--feed {
      .scroll-loader {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        height: fit-content;
        margin-bottom: 2rem;
        .ant-spin {
          .anticon {
            font-size: 3rem !important;
          }
        }
        p {
          font-size: 1.6rem;
          margin-bottom: 0;
          font-family: $font-primary;
          margin-left: 0.5rem;
        }
      }
      .message {
        p {
          color: $color-black;
          font-size: 1.8rem;
          line-height: 2.4rem;
          font-family: $font-primary;
          text-align: center;
          margin: 5rem 0;
          opacity: 0.6;
        }
      }
      .ant-typography {
        margin: 1rem 0 -0.8rem;
        font-size: 2.2rem;
        font-family: $font-primary-medium;
        font-weight: 400;
        line-height: 2.8rem;
        color: $color-black;
        margin-left: 1px;
        @include respond(tab-port) {
          font-size: 2.8rem;
        }
      }
      .feed-tabs {
        margin-top: 2.5rem;
        .ant-tabs {
          padding: 0;
          .ant-tabs-bar {
            border: none;
            margin-bottom: 0.8rem;
            .ant-tabs-nav-container {
              .ant-tabs-tab-arrow-show {
                display: none !important;
              }
              .ant-tabs-nav-wrap {
                border: none;
                .ant-tabs-nav-scroll {
                  border: none;
                  overflow: hidden;
                  .ant-tabs-nav {
                    border: none;
                    padding-bottom: 0;
                    width: 100%;
                    .ant-tabs-tab {
                      padding: 1rem 2.2rem;
                      border-radius: 100px;
                      font-size: 1.4rem;
                      border: 1px solid $color-dark-grey-5;
                      font-family: $font-primary;
                      color: #434343;
                      margin-right: 1.2rem;
                      margin-bottom: 0.3rem;
                      line-height: normal;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      @include respond(tab-port) {
                        font-size: 1.8rem;
                        padding: 1.2rem 2.5rem;
                        margin-right: 1.5rem;
                      }
                    }
                    .ant-tabs-tab-active {
                      font-family: $font-primary-regular;
                      background-color: $color-primary;
                      color: $color-white;
                      opacity: 1;
                      border-color: $color-primary;
                    }
                    .ant-tabs-ink-bar {
                      display: none;
                    }
                  }
                  .ant-tabs-nav > div {
                    display: flex;
                    align-items: center;
                  }
                  .ant-tabs-ink-bar {
                    display: none !important;
                  }
                }
              }
            }
          }
        }
      }
    }
    &--right-side-bar {
      @media (max-width: 991px) {
        display: none;
      }
    }
    &--left-side-bar {
      @include respond(tab-port) {
        display: none;
      }
    }
    &--mobile-sidebar {
      display: none;
      @include respond(tab-port) {
        display: flex;
        gap: 1.5rem;
        padding: 0 1rem;
        margin-bottom: 1rem;
        align-items: center
      }
      &--btn {
        height: 5rem;
        width: 5rem;
        border-radius: 100% !important;
        border: 1px solid $color-dark-grey-5;
        outline: none;
        background-color: $color-white;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 1.5rem;
        img {
          width: 2.8rem;
          height: auto;
        }
        .recommended-icon {
          width: 2rem;
          margin-bottom: -0.2rem;
        }
        &:hover {
          background-color: $color-faded-blue;
          border-color: $color-primary;
        }
      }
    }
  }
}
.network-feed-mobile-sidebar-drawer {
  height: 100vh;
  .ant-drawer-content-wrapper {
    max-width: 80rem;
    .ant-drawer-content {
      overflow: hidden;
      .ant-drawer-wrapper-body {
        overflow: hidden;
        .ant-drawer-header {
          display: none !important;
        }
        .ant-drawer-body {
          padding: 0;
          height: 100vh;
          .feed-profile-sidebar {
            border: none;
            border-radius: 0;
            padding: 0;
            box-shadow: none;
            height: 100vh;
            .profile {
              &__header {
                border-start-end-radius: 0;
                border-start-start-radius: 0;
                height: 11.3rem;
              }
              &__body {
                padding: 5.8rem 2rem 3rem;
              }
            }
            &__suggested-container {
              max-height: calc(100vh - 29rem);
              min-height: calc(100vh - 29rem);
            }
          }
          .feed-recommended-sidebar {
            border-radius: 0;
            border: none;
            padding: 0;
            &__body {
              height: calc(100vh - 6rem);
            }
          }
        }
      }
    }
  }
}
</style>
